import React from 'react';

import type { PinnedEntitiesProps } from './index.types';
import { PinnedEntitiesView } from './index.view';

export default function PinnedEntities(props: PinnedEntitiesProps) {
  return <PinnedEntitiesView {...props} />;
}
